/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const $primaryCtaLink = $( '.primary-cta-link' );

      const updatePrimaryCtaLinkHeight = function() {
        const primaryCtaLinkHeight = window.innerWidth < 850 && $primaryCtaLink.length > 0 ?
          $primaryCtaLink.outerHeight() :
          0;

        $( ':root' ).css( '--primaryCtaLinkHeight', `${primaryCtaLinkHeight}px` );
      };

      updatePrimaryCtaLinkHeight();
      $( window ).on( 'resize', updatePrimaryCtaLinkHeight );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'navbar', COMPONENT );
} )( app );
